<ng-content></ng-content>
<a class="type-toggle" (click)="toggleShow()">
  <mat-icon class="show-option" [hidden]="showPassword">visibility</mat-icon>
  <mat-icon class="hide-option" [hidden]="!showPassword">visibility_off</mat-icon>
</a>
